import axios from '@/util/axios'
import axiosNoError from '@/util/axios_no_error'
import { API_RELAY_PATH } from '@/util/constants'
import { isFromAdminSystem } from '@/util/common'
import store from '@/store'

/**
 * ログインAPI
 * @param  {} params={}
 */
export const login = (params = {}) => {
  const defaults = {
    _path: 'LG/001',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  // @/util/axios_no_error を使用する。
  // 通常ログインは、Login.js内でのエラー処理を実施するため、共通エラー処理をしない。
  // フロントエンドログインはエラーを出さない。
  return axiosNoError.post(API_RELAY_PATH, r)
}

/**
 * ログイントークンリセットAPI
 * @param  {} params={}
 */
export const resetToken = (params = {}) => {
  const defaults = {
    _path: 'LG/002',
    token: store.state.auth.token,
    login_id: '',
    password: ''
  }

  const r = { ...defaults, ...params }

  // @/util/axios_no_error を使用する。
  // Login.js内でのエラー処理を実施するため、共通エラー処理をしない。
  return axiosNoError.post(API_RELAY_PATH, r)
}
